import { configureStore as rtkConfigureStore, Dispatch, getDefaultMiddleware } from '@reduxjs/toolkit'
import { rootReducer, RootState } from './reducer'
import { Magento } from 'lib/core/services/magento'

// TODO: rename magentoClient to magento/magentoService
export type PWAThunk = (dispatch: Dispatch<any>, getState: () => RootState, data: { magentoClient: Magento }) => Promise<any>

// TODO: Type
const customizedMiddleware = (extraArgument: { magentoClient: Record<string, any>}) => getDefaultMiddleware({
  thunk: {
    extraArgument
  },
  serializableCheck: false
})

export const configureStore = (magentoClient: Magento) => rtkConfigureStore({
  reducer: rootReducer,
  middleware: [...customizedMiddleware({ magentoClient })],
  devTools: process.env.NODE_ENV === 'development'
})
